import React from 'react';
import cx from 'classnames';

export const RadiobuttonElement = function FromElement({ element, innerElemHeight }) {
  const { options } = element;
  const { alignment } = options ?? {};

  // Mirrors the field as it is filled in - see the builder checkbox element.
  const isRequired = !!options.requiredFor;
  const hasGroupLabel = !!String(options.label ?? '').trim();
  const markRidesOption = isRequired && !hasGroupLabel && element.inputs.length > 0;

  return (
    <div className={'element-wrapper'}>
      <div className="element-inner">
        <label htmlFor={element.id} className="form-label w-full">
          {element.options.label} <span className="required">{isRequired && !markRidesOption ? '*' : ''}</span>
        </label>
        <div className={cx('form-control-radio-wrapper')}>
          {element.inputs.map((option, index) => (
            <div
              key={index}
              className={cx('form-control-radio', {
                [`form-control-radio-${element.options.size}`]: element.options.size,
                [alignment]: alignment,
              })}
            >
              <input name={element.options.label} type="radio" value={option.id} />
              <span className="radiobutton-form-builder-elem-label" style={{ fontFamily: 'Arial' }}>
                {option.label}
                {markRidesOption && index === element.inputs.length - 1 && <span className="required">*</span>}
              </span>
            </div>
          ))}
        </div>
      </div>

      {element.options.instructions && <p className="instructions">{element.options.instructions}</p>}
    </div>
  );
};
